import { Routes, Route, Navigate } from 'react-router-dom';
import { OnboardingWizard } from './onboarding/OnboardingWizard';
import { AppShell } from './components/AppShell';
import { RootRedirect } from './components/RootRedirect';
import { LoginPage } from './components/LoginPage';
import { DashboardLayout } from './dashboard/DashboardLayout';
import { Overview } from './dashboard/Overview';
import { Products } from './dashboard/Products';
import { Customers } from './dashboard/Customers';
import { Subscriptions } from './dashboard/Subscriptions';
import { Charges } from './dashboard/Charges';
import { Invoices } from './dashboard/Invoices';
import { Disputes } from './dashboard/Disputes';
import { Refunds } from './dashboard/Refunds';
import { SubscriptionChanges } from './dashboard/SubscriptionChanges';
import { Audit } from './dashboard/Audit';
import { Settings } from './dashboard/Settings';
import { Team } from './dashboard/Team';
import { Billing } from './dashboard/Billing';

/**
 * Top-level router. Three surfaces:
 *
 *   /onboarding  — the setup wizard (Connect → Map products → Import rules → Done)
 *   /dashboard   — the admin console (M10a: Overview; M10b/M10c add the rest)
 *   /            — status-aware redirect: /dashboard if Stripe connected,
 *                  else /onboarding (see components/RootRedirect).
 *
 * Auth is enforced server-side by the Pages Functions: every /api/* call
 * carries the session cookie, and the proxy injects X-Tenant-Session. There's
 * no client-side auth gate — if the cookie is missing/invalid, the Worker
 * returns 401 and the view surfaces the error.
 */
export function App() {
  return (
    <AppShell>
      <Routes>
        {/* Root — status-aware redirect (Stripe connected → /dashboard, else
            /onboarding). /auth/start bounces here after minting the session. */}
        <Route path="/" element={<RootRedirect />} />
        {/* Login — the "Log in with HubSpot" entry point for logged-out users
            on an installed portal (M20). */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/onboarding/*" element={<OnboardingWizard />} />
        {/* Dashboard: shared layout (sidebar nav) + nested views. All six M10
            views are built (M10a Overview → M10b sync-status browsers → M10c
            Audit log + Settings). */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Overview />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="customers" element={<Customers />} />
          <Route path="products" element={<Products />} />
          <Route path="charges" element={<Charges />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="disputes" element={<Disputes />} />
          <Route path="refunds" element={<Refunds />} />
          <Route path="subscription-changes" element={<SubscriptionChanges />} />
          <Route path="audit" element={<Audit />} />
          <Route path="settings" element={<Settings />} />
          <Route path="team" element={<Team />} />
          <Route path="billing" element={<Billing />} />
        </Route>
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Routes>
    </AppShell>
  );
}
